'use client';
import { jsx } from 'react/jsx-runtime';
import { useRouter, useSearchParams } from 'next/navigation';
import { UIProvider } from '../components/_UIProvider.mjs';

const NextUIProvider = ({ children })=>{
    const router = useRouter();
    return /*#__PURE__*/ jsx(UIProvider, {
        value: {
            navigation: {
                back: router.back.bind(router),
                push: router.push.bind(router),
                replace: router.replace.bind(router),
                useSearchParams: useSearchParams
            }
        },
        children: children
    });
};

export { NextUIProvider as N };
